export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.origin}/`,
  },
};
export const LOGIN_PROTECTED = true;
export const BETSLIP_AUTOPRINT_MOBILE = false;
export const BETSLIP_AUTOPRINT_DESKTOP = true;

export const getHeaders = () => {
  return {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  };
};

export const getTextLogo = () => {
  switch (window.location.host) {
    case "gatepro365.com":
      return "GATEPRO";
    case "bet365tt.net":
    case "bet365tt.live":
      return "359";
    case "swissplay365.com":
      return "swiss<i>play</i>";
    case "romaplay365.com":
      return "roma<i>play</i>";
    case "838bet.co":
    case "838bet.net":
    case "838bet.org":
      return "838<i>bet</i>";
    case "royal365bet.com":
      return "ROYAL<i>365</i>";
    case "leone.bet":
      return "leon<i>bet</i>";
    case "bets555.co":
      return "bet<i>555</i>";
    case "365berlin.com":
    case "365berlin.net":
    case "topibet365.com":
    case "topibet365.net":
    case "zbavitu365.com":
    case "better365.live":
      return "365";
    case "betvip355.com":
      return "VIP";
    case "luckybet01.com":
      return "001";
    case "winbast.net":
    case "eternawin.it":
      return "WIN";
    case "prado33.com":
      return " ";
    case "sport44plus.com":
    case "plus44sport.com":
    case "sportplus44.net":
      return " ";
    case "zzbet34.com":
      return "zzbet<i>34</i>";
    case "betmania24.net":
    case "maxlloto.net":
    case "maxlloto.com":
    case "betmania24.com":
    case "betmania24.co":
    case "bluebet07.com":
      return "BET";
    case "monako1.com":
      return "monako<i>1</i>";
    case "ela77777.com":
      return "ela";
    case "ela77777.com":
      return "ela";
    case "baste247.com":
      return "BASTE<i>24</i>/<i>7</i>";
    case "bob365bet.com":
      return "<i>bob</i>365";
    case "euro365.live":
    case "euro365.co":
      return "euro<i>365</i>";
    case "365eurobet.com":
      return '<div style="text-transform: uppercase; font-weight: 700;">EURO<i>B3T</i></div>';
    case "tipwin356.com":
      return "tip<i>365</i>";
    case "blu90.com":
    case "localhost:8080":
      return "blu<i>90</i>";
    case "maxbets365.net":
      return "MAX<i>BETS</i>";
    case "maxb3t.com":
      return "max<i>b3t</i>";
    case "bileta365.com":
      return "bileta<i>365</i>";
    case "gota365.com":
      return "in<i>bet</i>";
    case "albwin.co":
      return "alb<i>win</i>";
    case "luckybet77777.com":
      return "77777";
    case "redvip247.co":
      return "redvip<i>247</i>";
    default:
      return null;
  }
};

export const getLogo = () => {
  switch (window.location.host) {
    case "365omegaa.com":
      return `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA8CAYAAAAjW/WRAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAACH6SURBVHja7J15dGRXnd9flfZd6pa6W2qtpdJS2mp59apK6sXAYLfNmpmB4QTIDJBMBtswzAEyxMCQyTDAJMcLxA7kkJwhk8OBZBIYbGNPQiaYxZhuY2wGt6pK3WqpF6m1tFSSSqr9vffJH/fVIqmkVnerbQP1x/dU1auqu/6+v/u79/5+90qqv3ZWD0hrWlBa0wMFFFCAHpDWtIBpTQuUzEqpQC16QEILSuiBAgooQA9IaAETWqAEKRWoDRcIUkABOeQIZggSLhCkgAJ2HkEKBCmggAJBCiigQJACCigQpIACfnMn6RQ657WFYGEEkVT/ZoLgl9D9ZvGDW2ogkwEJNbiZgPglMPLQ/abMezVPfvjNBiTwmwx2pyshoftN6H7zvmqP3Dpo/iJ0I/+diKwZdSRdb3+RKNce2oictPPWf1NbmGDcLOrrL0ILmIUQ+/dZewZFu+vjO9TD6LNNcnO7lafflJGBV4QgfhNasDgspQyC6EbDqAEzWiArsIJJNw4huIIkajBHmDPfFWcF21+EFijK5LspncyzNBmKjOfZ8jFuvuly5kI1lALjZtSgieQ5idSESFsIsQnGRfm1YO5/RZvpAYlU0IQaKNpTR+IXwi6E0oTmL87bjmnFoAdE/6SCJlKBIpLBIkHMcbMo0z60geY3owZEuTibvx5qpm9E3TNtErhdEEpANZSBFpBuTz5BIYucLUEfLzIIEsgSRGim4k3aIF24m9bE/uwokCaDGigilcnPTGpCQg2adhjqDAL5S0hNGGkFzOAvQgtKpCb21zxk3ATjxahBU6ZDxEhYZHSMebtW9YtRUfObUIMmtAkJ9lKmjAIxofqLxWi10++MPEUnmjZr7H0cQRkvRguIPklr7m0EmZCM700ZwqTf3y7TWzOUw+02+/CbhbKaMIG/ZDNB0qaCPi3BnIQ+L8DcjUObz/5fX5DQZ4TQ4JeM0cnQjuMm9HETXDLBvGlTGvq8BPMmtMkitLPFQlMGJLRZCeaKYNYs0p+7uTJuRTYdE8xIpM5J6OPFaOMmtEkzzJrQ5iW0BSlvOZkyC01naNbrdYYaNNr7rATTxWiLpvxpz0kwU4Z2wSxGjLNCwXDFBFeLURduvp/yQV0w6jhvRruUT0maSRkk4ooEV837lvc2zEtw0RhFxotJBSQhKwu3Jz99XkJblNBnJVITppxJut8gxnw5yV/WEPu/DSSfaCD1ZAPJpw+QfOoG8WQjiacOEP/7WmJPV5L4SRVcqoFLZkO7CnKoExKpcyUkf1xJ/DsNpL57MJNG6qkDxB4/SPJ0JckL6dGjlPiPK4g+UUPyiUaSTx0k8dRNlG8HJJ46TPyJgyS+X40aKBMCfN5E4nkzkb+tJ/VEE4mn67P/efoAqScbiX2rgcRPatEvlxlmWtGeNFYqKKFfLiH5ixqij9eTfLJxc3s/3UDqqUai//MAsecqUCfN6BMSqWAx8R/XkPjOIVLfPUji6YZ9qv8BEt9tJPVEE9EnK0n+shyubp7rMG5GmzCRChQT/T81xB4/QPK7+9cHWRwk/vgBEs/WCiU5IaEGSkg9c4DE4wdvQ36i/tHvNBL/Xj3qRFlYSgaqwwQktCsSnG9g/UuHCL+tjbXRPqLyCEmXnYQ8dMOIy8PE3ENE3TZi8iDhO3oJfayJ5OkGmCsRhPRLpCYluFLF8p8eZrW7l6Qzm1/K4eRabyehx+pgsRT9vAQXa1m+r4VQt5W4PEJMGSLmHrypMuYtt8tOuMfGyntbIFCLOi3BtInUS1XM/k4L0fYBEu4BYm4bCdlGVLERl+1s2Gwsvqmd5JnD6IsS+rgxH5mQYFxo4VTOe81vFhPBqxLaeCNL72khbOslIduJKv1EFRsRZZC4Z5CYdYDZNzQR/UEdTBXBeQmmq7j2J4dZs/aQco6QkIf3of7DxOVB4u5B4vIg6yM9bLypm8Q/HEJfLBYE8QuTh4sSqRfqmHt7K5E+2/61vzxE3C2QcNkJd/ez/udHYK4c7YIEl6tY+Vgb4S7bJlnZn/oPEXePsN4zxNq72mC8Liyp/uqwPiWhT1Wz8q8Os9Y2gN7ugwEFhmUY9MGg13i9EeT+ZwysY0RaBrl2TwuJZ5phpkSYI+ckmC1h5aNtJJs9YBvL/q//BButQyx/6QBcKxcEuVxN6F+2kjwsw8AYDPluomy7YMCD3uwl9s4etPOVJKeFsHO1mMS3WwjbhqH9JIx4YXDUgA8GTxBrc7L8zxvRpqvRL0noZ4U9j19CNxYSxHxLgrNmtGkJbaGG8MdbibYNQ/8JsI3CgA8GRmHYC5bjhDtsxL56FObKxchzXkK7XM7qfZ2kWmTRvply3CoUGJIFBr2ozTLLb2wl8Xy9MOnGjXnQJYnYCzUs39UHbcf2tw+GDAyMkWpWSDzQBfOlqFMS2mw5ax/pItEsg+04DHoMGdiv+o+iHx0l9ttWtEBFWFLPVodZKiL81cOEOnth4CS64gaXG5wyyE6QXbcIJ8huGDlB8rCPpfccRTtfjT5tEGSmlJVPHCVucYFTyf7P4WW9p4/QYw2wWCYIcqmalfuPEu+0g8uD7naDLO9DGQ24ZFSLTPQ9FrRzlWhTQusTlGCljPUvHSXcaRMNqbjA5QKXG80j6hdrsRP+80OwVIl+QYKXzZnlXD1gInnOhD5ehHpeglAxG189RNgyDLZjaIoD3aWAU0FzO8E+RrRtmJU/OwoL1UJAAhL6OQntUjmrH2kn2W0HWdnHNnAb6SniveMEicNuwh9rQpspE3kbBIn/vIblt1rRez371v667EJ3C+Byk7TYif+bdpgzCDJTztrHO4hbHOD0gSwbMuDet/qrVoXouyxogcqwlJosD+tTZYTf3Yl21IfudqO7ZXD60Nyy6Cg5LYTylvd7hQtcHjRFgYHjrPfaiHyzCeZLhKBsIogn+z+Hj/We/h0I4thCEHcO5JtHhiDdgiAXjL0BfwlMSTBTyfKHDxFtHQan1/iPF01xoioy9LyOlT4r0a8fgeUyw5TM7hmo/mI4a0JfLiL+dDMrbguq9Ti6rKC5HWiuUaGcZDepVpnVd7egTdWhzUhoxhI32wjiufV6b2pDJQPdraBbj7H++i4SpyuFKR6QYBtBdkprJ5nJX15ddhsy6AaXh6TFSfwzHVsI0m4QZDSHIMr+9L+sbCHIbFk48dMK1k9Yoc8Lsg9d9qC5neiyjK7I4HaDSzE6bqsw7gDjt7mF12U3uLzEOkYI/1thV6qT+QhipOEYZb3HtoUgVYQ+1Eysc1iUKW+jbNGCW7GtQbPQZRm120XsPV1o5yvQLhhL00GzEPZ5idTLdazd3YbWKdoL2Q1OD5oso3pcaN1elo53kvzhIfRlE8mABP4iYznXBLMS2stNhN5qIdnpFfm60krJKJ/Fy8pYJ8kfN8A1E+qEKbsJeU5Cu1y2mSBuxajXDSDTDh5BBtkF7s39q7udaANeNsaGSH6vHnVOEsvs2wji3kIwWYwCmb5R8iixfO2fjyCdMFeKliFIpyCIy2vkI29OM63k88qlbOSjCHnM0x6q1UvkXd3CxNJnqsKJH5ax4esTdm+mgC7xB6cH+r3QMwrWY9Dng96xzegxkPl8DKyj6EOj4PZubiyXl7jFTuyBFpgpRZuU0GZLWf3EURJ5CTLAyqMHBEEmjTnIH1qIH7RDtw96TkLvcej1QK8CvT7oGUMbSTeIkhl+NbfRqENe6PGKcm6tS+8YWpOP6O92oZ2rQpvO7gVoxijAUhHxJw+wYrdCz5hQIhmN6wKXj3inzNI7WtEnG9BnTWjjIg0uSjBTx8qHW4m1Dxta0JUpq+5xwKCPcG8/kb9phmsV6Dl7DrrfJNrscjmhD7aTPOQB6+tEG/SN5a1Pfoi+1G2jok973GBTwOnN1sdlmNg2D5GTQyS/34A+m52kx1+oIfQWK/R4ctpZBrdTmOc2BXpHDRht3TdqwJf9rm908/M+L/R6wTqK2uQm+q8taAvlYgS/XEn43j60gx7R131e6PPkpOVF7fXB8FjOyCoEX5Nd4PDAgBetzwc9J/LIwDH0Q2NsvN2K/nJtWNKvVIeTPy4jMtYnJsi5jHIqqLKTlTstLL75KEunLCyd6iF0VzfLuyB0Vzfzb7aw+rpB9BE3OF3oaVPN5SVucRC/GYKcl2CqmqVPtDDva2PpVBdLpyyE7upi+a5Olu9qZ/lUJ0t3W1i/ox/d6RIdbZhhuqygO7xsnOgndE8bK5vKbWX5Lgsrd7ax4O1k4f5m9IkqmNzu8qBPSLBaRviLh1nvGoGRtJDLWVvYPspGu5O1j7fBnJjL6OckWK5g46F2wp09YnK5Sfu5wD5GpGOYtU+1wLU6UlPbN2q18xLadDlzn25ibrSN1Tt7CZ2yEjrVbbxacz7nYsuzu7pZvtvK0j0dLN3TzurxHpIORw5B3GKOZVOInBwk+Uz93gjidKEpLlbf2EfoVBehUxaW7u4kdKqT0CnLDujKgfjtyp0WFnxtrP27I+izFWjG6t3Kn7Wy6O0Qv727k9DdHSyfsrJ8dw9Ld3exeLeFyPERcCibzTeXG+yjRE8Oce2eDkJ3WQxZtmRkIHSnhSVfO4t/1IR+tno3gijQq7D2NiuRHx0i9osKYmcqif+0lvjpWmKna4idrt0C49mZKmLBeta+2EZ0YBBGPCDbMwSJWRzEP3kDBHnsgFjmDUhogWKSL5YTPV1L5Ge1RM9UEj9dJfI+U03sZ9XEgw2sP2Ah1uNAdwszT5e9MHyMDVsvy3/VTGKinujzlZvLfbqG6PNlRJ+rIfFCLeqEsZG5dYPPbzbmI9WE7m8h1iwb8xFnZlFCdysweIywtY+NLx9BXy1GD0vEH29ifdgqtJ3LvWUhw0OqRWH191rRLjSgXpXQxrcTBL8YyVI/ryH2XC3Rn5UTO1ND/HQt8TO1xNI4LfoqjVjOd6IP64mfriH2fAXRX1Sx8b2DbLzZAv1G/7s8oow2hcjJgb0TxOZh5fXdrP39IeL/WEfsdDWx54X8xE7XED9TTexMNfEz1cTP1BA/Y/Rd+vNpgdiZGmLP1aG+WCN2tsfFBnPqxWpiP60Vdc78v4ro81XiWaCZ8Oc7ifcMbV70cXqJ9g2z9tkO4uMH2HixhOiZ6m0yEHuugcTz1STPma5DkG4P6/+kj9RkBSyK3XD9sgTXwxUJoiYif91EvMcFI8eEvef0gWOUZKdM4oGjN0UQfbwELkikrkpo+fKdlWCjmNUvNLLePYyesX89MDLGurWX0H+sg0ix+P2WNPQrxq7/tOFkmWdHXAuY0M8WoV+VSLx4gJU7u9E7fGIekDOXQXGh93pZla3Enz2MOnmI0Kk21E7x3SY73K2gd/sIebtI/egAXBNzHsZ3cIc5a4ILEuy1T66HRQmu1JL4/T50i9MgiE+QxOa5MYL0eVh+vYXIC9WwZqR/aQc52YMsaVPGRrbhfydMLSPNHOhXjDQjZUT/w1FilhFDcaXlyceG1cHqo42wXox+dYcyXBH1U69LEKuXyFv7SLxcIpZkg1k7fDeoExL6tVLCX2ok3NhPst1DvNtB0uIg2elmvXaIjY82w6zY/NkzQYISWqAIDP8tPe3d6TcZflKSMH/mSgl9roFI96AYZtOTUfsoEesIoUcaYaFke13SHrxBw3N4Bw9jPSCRnJCE28NSKaknG1kf7oG+Y4bJpBgCo4DsQ+1xEnmHjcj7+kj0OsA1Ci6nED7nqBhtBnxs9NiI/M0hWC1CnzA2E3dwxdbHS0hOSMZGpHlP/ZIPekCCsybUaYnURAWxd/eCJU1cj0C/h8hJG8ln6nYhSI5p3u9l5Y4+Ij+qFRuhhkOj5s96dqtbyqBOZL2Z85VRNzZadX+R4a60GRgezvqEBAvFRB88Ssw6DE5fdjLu9BG1ulh7+DDMFUO+NsnxAdQCxdcnyMbbekj+sgymd3ZeyxdHwHQxsSdrWPtYK5FPWYh8up3opzrY+HQH63/cRvTrtegXi4U9fR2ChB49CIulmYbN72RmICjB1TJWP9tI1DIMjvSkM61Bhll5uDGT3i07uJ2XYLmY8INH2OgcBrsXVTFMrMyk1SMWEXq8IHuzqzouj1htsfuItjpZ+2QzLJShX7iOg6hfaFQum2HeLPyV5nN8l7ZiLs93c4af24IJ5iX0VQn96gHi7x2ETvfm1cB+D5E7bCR+sEeC9I2x/Hor0V/WQNQsfNvy+VjNm+BKUcbRUw+Yb9qdHSPsQZuQYL6MjYeOEukZBNeoQRCxShjrGSb80FG4Woa2i6NrJh7kdhCEcQntrAl1qgjmqtHnymGmAmYq0OdL4GolTOVo8H0gSAYTEsyVsfqXjUS78hFkiJWHD+4bQfBLqJcktJkGVj7YTKzNLlaCMkucOcveLhnd5UR3ubIre26F1FEny+/sQp2uR5sRO/fX825lwkziH6qJ/Pd6Yt+uI/rt2ptADdG/qyHynSqi360l+p+bib2hT3hRbCXIyesRJGeZfcBD+GQ/a187QvTpeqLfqiH6rSqi367elP/G/6gl+r/r0IOlhlyZbileJB06wML1CNKyK0E2RRTelhEk7aIdFAKrByW0c2IVRw8K/6u085s2cRsJYrn9BMkEEM2bSf28gaXfOora6RX2+7Z1+C2bUm4ZrcvHsq+T+DMHYCkd63Kd/CYluFjB/EcaWeqyEBu2E7HbiNj7bwA2ovYeoiN9bDiGWXMNEB2woQ87tsyPFOhXiJywkfxBw94I4pbBqRC197PutLLh6GPd2c+Gw5ZBxD7AalcvV/9ZG6mJAzAl5TUnf20JkrEnAyK+QjNcLRgXQT7CnjTtG0H2bmLdBoIETMJfa6mY6N81sZKZj7jzbN4p2U2pgTFW+qysf70RQiWZjmEPZp12qZyV+ztQj/pg8Ljhv+TN+jHtCQoMjcLQMRj2gcMrBN3t2EaQ6B03MAdxGyPmiOEnlluu4Ry0jrL+T3tITFbApHRLUaw3ZmK1vLomVsatIkegd/rfK0+Q4X0nSMY797wES5Wsf6GVaOsIDI+huRXDv8iRGVU0xQGOY8SPjhB+oAUWK9EnpT2G6YoRRL1czupHOklajMl+Ps8A126QDSjgNPzuclei5OxGq25VWPu9blIv16BNG6EKF42d9LdYxfxqR48Kz7Zd7Ey63W5W3t9GcrIMJkXQ3O0nyMhrgyB7Fq5fixHEWE06a0a7LKFfqSP0vqPE2lzg8qK7HahuNzi9aMoIuttDol0m/I5W9IkGsXw+bgjeHk0sNe2LZRnZgSDGStqNQt4+4uk9PsJvt6K+eAhtxrAEdnU1cWfcOcRGrbK9PE4PukUh9L4OUucrxdJ9UPrNGUFeaYK8WpP0dJtoAbOIJPRLaEsSyRfqWTvVLVwaXB50lxdkh/Ao6D3Byh1dJJ6ph6WceO7gzRDEvvMIkvbPymDr563f5fEKdrvAcYyoZZi1TzfBTLVwMN0DQTS3kvGrElCyecketO40QSr2jyC/MpP0PCddkINfpxFEnDZSJPYl0mmulxF9qF2MIs4x4bKh2MHhI9GmEP0LC3rY8LMaLyEVLN77JHVXghjLygNesHqhx5cDbw7yPLMaPlBOZZPToq7I0HUHqye7iZ+uEiPebgRJO7f2eoS/nNXAprxGodHH8jstJCcrYEoi+as5gvSKsMtpaVNcw/WgBSS0SbHTi7HDqc9IqLNGTPmF/V3FejXnIBn3j/TxP34JfaWE9UcPEWsfybg76G6xWRXrHmHjC61o10ozm5LpDco9lWlXgihoTpnYbw0QeXs3kbd0E31zN9E3W3Ne8yPytm5id/WjGi78Qqi8aIoLBrysHxsg9v/qRJ/uRhCnQkqxE727h+hbLUa+3UTfsjn/jZNWQn/SgnZO+LypmWOTsifi7HXp91Wcg/TmjCAm43wis/G6A8bNaBNFpM6WEz9dS+JMFYkzVcSfryT2sypip6tRXyrLLP3+OhBkm5m3VETkoSPEO1xZdweXAk4f8S4H0c+2wHyx4al7g9hEEIcxdzAI6DjGiq2f5a8cRL1Yg/qLMtSXKgxUor5UJV5fNPBSDoLlJJ89ROyeIfQ+N8g5q1k2L+E7+oj/8KBQeNsIoohNT5cYvUKv72bje02oE6WoL5Wj/qLcyDebf+rFStRfVoO/NNt/46YsDHn6FRhBNptY+It2gRkCJrhaQfi/HmDhZAfRNwwQvbOHjbusxN8wxKpiZf1zh+BK5Z58sV7rc5DdCSJvJojDR6LLSfSzR28DQWSwjxLq62flv9XDepHwU7q4RyxIcK6W2O/2oPXmrHbJbrD5DIIcuD5B+n0svbGd2AtVsGykna8cl0xwwZxjgudXuK/ROYhbEOTtfaTOlgpnsPTpgcHrYEJCD0msP9ZI/IgCXSegV0HvV9D7PMSbZKIfbxO+WAWC7DtBVvpthP5LHSyabyz9ixLay5VE39GN1usxvHmVGyeIzcfSGzqIPFclgsOC20/X1AN5ZCZ488efvjoE6faw8dsDqLPVsGGCxRJYKN6Cou2fF4tALyfy9UMkuu1g92RsU112kbA4iH+yFWZL9o0gr/Yy72uDIMLEWu7rZfmbdaCVw6I52zeL5t0RMaFPHST21gG0bmeOiaXc8Ahy7Y3tRF+uh3gRLJiFTOTLc6EYFtJyZd4uT9eK0S8Zbv+viol1uSYc/0kp68ezEYUZDCqsv3GQjQfbSDx6kMQXG0k8cojEw80kHj6SH48cIf7IYZJf6SD6IQsxxwBaTjQhToVk1wjxT7XA1eI9Bky9hp0VX3WC2DfvXzi9JIYdRD9kJf6fmkk8ctjoL+N9BkcM5Dz7chOJB3pIKi4YzvpjaW4FbMcJ39FP7IcN15mkKzDsZeNEHxt/2U7isWYSDx0h+XALyUeOkHj48HZkynGIxCNNxL94SOCRw8S+cJjUt+tgWgSqZby2b2WS/uANOCtqV2rC8WdL2RgdFCNIbiyvopB0uolZncStA8R7bcStIySsdhLWEQO577Ofk1YbqYERNMUjPFhdhnOeSybZ5SBaGEH2kSA5q1huGWQver9MvHuIuHXEgH0PGEG1uMGugJL1H9PcLhjw7ZEgxj6HSybRO0zCYidudQi56LYb8pGLHNnpthO3DhPvGSLeM0TCMsJGwyDxT7TAYjHaObHSlS9G57aNINpMZTj+bBlhnw36jm/f8HF6weETcRUOD9jHjM/Xg4hn111esWGk2MWQ7fARszgJf/owzBTmIPs3gmzZ4HO6we7bY1/lwOkWhzdkYKRrc7J6Ry/RHzRmgpV23Sh0KcK3K5O2d4/5e7Owj5JqV4h/pg19vhRtQhwMrgWKXrk5iHqxIqz+Yxkrb2pHt3p2OX3CiMozjtrR06eU5HPEk92Z842Ei4Gx+eT0gP0E690DhL9UD/Nl+xYPknUDNwjyGzeC5DnZZZPvlbKzn9auXseGP1Wfl9DrLMSerd8bQXKODkoHj+mysoPsKNmzrYwTSXS3OEMge+xP2abbB14xgqQmKsJcrST80XZiLQNi1zftspy7Oysbsb1ux/YGyAeXYjjAOYU2c7lEdF2fj5C7m+T3D6JfFcKkzZYZx/448xPksYOZiMIbNrHsvmzjO1/hOciDzWIfJK3hXeLUkESXk+hftMJ8yS0SpCPnXCwlvxa/JX8sRZxQ4najt/sI/04XaqBWHIh3SSL+4u6uJvmxu9ykj+PRZTe6y0PS4iL+GXFwXGY17LpzkFI2HjpKdFeClArZu56JlRqvDXO1mOT3G1nxtZNqdQszyuURwppe6kufi+UyNMqeIOIidGPkoec4Sx29hD/fCjM1JM6LOBFmS1n701ZSnQ7D5drIzz5GpHuIlccaYLEks+SH/zrRjHPlLH/uMNEuB4yMGa4eXhjxErU4CT10RNi0E7eJIEERZRh9qIV4u7FR6FCMmPxjJDsUop9thoWbG0G0SYnU5XLW/rgLtdPwxnXlEsJzi8gNGVag/yTr7b1sfPkQ2oJQVFySiL1UxeqbeqB7bI/kS8vEHsvh8KF2ukl8pl0cPToh7by7nnMVBvNlRP99OwmLcO3JKA/7MZJdHtYfOow2X5yT3m4E8deFCUroi6Uk/lcby3e2E+7qJ9XqJWlxk+x2krS4SBlIWlwkLU4D2ecCzsxvUl0uUl1uA3birQ6Wh/tY/XwT2sUq1MtiuBQnK5axdP9R1uvsqJ1KJl2tw8vSwV6WHjwI1ypInTPiJXbbPJqQYKGc5QeOsFZvI9XlMMrlINXm5lqTlcUvGCPIxG0cQUKlrP1VI+GaQdS2YyS7XCQtdtQ2H5EaO2ufPiTCa2+iDExK6NPVLP5hC+GGQVIdni3948rTN7n95tzx+db/JdsUVtr6WftEM/qlWhIXjRjwSxKJM/Usnmgn2ejKm/+2tLbIT74ypHKeq51uIvVDrP9pO8zVZi95CuaPyUml72ZZrGbt80dZa7Chdsqi7y12Up0Kq43DrHzuCPp8OanzexlB/HVhxiXU8xLqQhnJn9cSfrie1Y+0sHxvG8v3dhK6rysHnTno2vG7lfu7WLnfwvL97azd28b6J5uJPFEHVytQL0viThC/WcwZpspY+koTV9/XycoHuwjd20no3k5W/8jC7PtbWPvbJrhUvvuFOWnSBCW4XMLq1w6w8ActhO5rJ3R/uyjXvT3MfKCZlW/Uw8XS3UeiW73b70op6984wNzvtxK6z8K1D7ezdH8Hqx/sZvG9Haz/tajTTV0IMyHBZAXXHm3k6vtbCd1nzdM3u/fPzs9zvvtgF0v/op21LzahTzXAJQl13IjZmJRQX6xh/pNHWPxAB8v3dbFy3TLs9TvxbOVeCwt/0MHq15rQrxjKxL9zVKeWDju4Ukr4m03Mv6+V1Xs7Cd3Xwcr9HYTutTD7gTbWvnEQpkt3DEzbcolnXVicbGEWGnpGgrkKtJlStKkytKlq1Oka1OnqG0LqYhWpS+JVvVQJ8+XigpLzojJpW1JNO/hdqECfqiU1VUlqqprUVBXJqSr0CzXo58oMR7adCJK+0i339MFSUhdrSE7XGHWoQp2uhgsNaOfKxIkkgaLbQ5D0rVMTZWhT9aSmK0lNV6NeqCY5XYk6VQfny276tiQ13Q4XqtCm61EvVtxw/+wJUzVoF6vR58tIXDROuT8rVpFUfxFa0AwXGlCnakhNVd+WMmjTdejnqkT/p++q3O18gKBEyi+hByvRputEu2fqU41+oR7tfLkg2njxjkFqOZd41oS1CePWp/R9c0EJ9YIkTte4VZwX2kY/l/UGzlwUmXMoGuckOC/s61zoFyS0cyaSEyYRL7CTeWVctpmJEZ+QxJFCF4RJwqQ4X0m/IMqipo+JuW1XeUnZMqTrcl5CnRJtq50z71yXvdzAOi5OWNSn9qmfdoE4vDsdr2F4dKc9bo0yaLcxf9K3cJ0V1+7pO1gQ6ctgU36TkLd86U0Z895xaVdv4bzXQGtbNOB+a9Rb+n4/8vW/Bq6c3qd6kpue/1Wqy2sh/9vU/q/Je9ILKOA1cUd6sECQAgooEKSAAm7+pJrMJL1AkAIKKMxBCiigQJACCijMQQoooDCCFFDAa2OSXiBIAQUURpACCrihw8hzCEKBIAUUkHeSjpQK1M7qAWlNC0preqCAAgrQA9KaFjCtaYGS2f8/AGO/F78pPPC6AAAAAElFTkSuQmCC`;
    case "probast.co":
    case "probet.co":
      return "../src/img/alfa99-logo.svg";
    case "sbo365.live":
    case "redbet1x2.com":
    case "extrabet.net":
    case "vienabet.com":
    case "vienabet.net":
      return "../src/img/as.png";
    case "mdcr7.net":
    case "zcr7.com":
      return "../src/img/cr7-black.svg";
    case "eurobet366.com":
      return "../src/img/eurobet366-logo.svg";
    case "betton777.com":
    case "betton777.net":
      return "../src/img/logo-betton777.svg";
    case "worldsport366.com":
      return "../src/img/worldsport366-logo.svg";
    case "diorbet.co":
    case "diorbet.club":
    case "diorbet.live":
      return "../src/img/diorbet-logo.svg";
    case "ponxhobet.com":
      return "../src/img/blue-lions.png";
    case "kingbast.com":
      return "../src/img/crown-logo.png";
    case "alobast.com":
      return "../src/img/goldwhatsapp.png";
    case "win356.co":
      return "../src/img/win356-logo.svg";
    case "kuqezibet.com":
      return "../src/img/albanian-flag.svg";
    case "cfc365.co":
      return "../src/img/celtics-logo.png";
    case "365arena.co":
    case "365arena.net":
      return "../src/img/logo-betway.svg?v=1";
    case "365kosova.com":
    case "365kosova.net":
      return "../src/img/365kosova-logo.svg";
    case "365albania.com":
      return "../src/img/365albania-logo.svg";
    case "raibet.co":
      return "../src/img/raibet-logo.png";
    case "kolina365.com":
      return "../src/img/kolina-logo.svg";
    case "bigbet77777.com":
      return "../src/img/bigbet24-logo.png";
    case "bigbet355.com":
      return "../src/img/bigbet355-logo.png";
    case "lek365.com":
      return "../src/img/logo-dollar.png";
    case "porta365.com":
      return "../src/img/logo-goal.png";
    case "eurosport365.net":
      return "../src/img/futboll-player-logo.png";
    case "kosovabet365.net":
      return "../src/img/kosovanet-logo.png";
    case "maxb3t.com":
      return null;
    default:
      return `data:image/png;base64,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`;
  }
};

export const getTitle = () => {
  switch (location.host) {
    case "365omegaa.com":
      return `CITYBET`;
    case "vienabet.com":
    case "vienabet.net":
      return `VIENA`;
    case "probast.co":
      return `PROBAST`;
    case "bet365tt.net":
    case "bet365tt.live":
      return `359`;
    case "swissplay365.com":
      return `SWISSPLAY`;
    case "romaplay365.com":
      return `ROMAPLAY`;
    case "mdcr7.net":
    case "zcr7.com":
      return `CR7`;
    case "betton777.com":
    case "betton777.net":
      return "Betton777";
    case "worldsport366.com":
      return "WORLDSPORT366";
    case "diorbet.co":
    case "diorbet.club":
    case "diorbet.live":
      return "DIORBET";
    case "365berlin.com":
    case "365berlin.net":
    case "topibet365.com":
    case "topibet365.net":
    case "zbavitu365.com":
    case "eurosport365.net":
      return "365";
    case "365arena.co":
    case "365arena.net":
      return "ARENA";
    case "luckybet01.com":
      return "001";
    case "win356.co":
      return "WIN356";
    case "winbast.net":
    case "eternawin.it":
      return "WIN";
    case "prado33.com":
      return "PRADO33";
    case "royal365bet.com":
      return "ROYAL365";
    case "leone.bet":
      return "LEONE BET";
    case "bets555.co":
      return "bet555";
    case "365kosova.com":
    case "365kosova.net":
      return "kosova365";
    case "sportplus44.com":
    case "sportplus44.net":
      return " ";
    case "365albania.com":
      return "albania365";
    case "zzbet34.com":
      return "ZZBET34";
    case "raibet.co":
      return "RAIBET";
    case "cfc365.co":
      return "CELTICS";
    case "kolina365.com":
      return "KOLINA365";
    case "alobast.com":
      return "ALOBAST";
    case "kingbast.com":
      return "KINGBAST";
    case "ponxhobet.com":
      return "PONXHOBET";
    case "bluebet07.com":
      return "BLUEBET07";
    case "ela77777.com":
      return "ELA77777";
    case "betvip355.com":
      return "VIP";
    case "bigbet77777.com":
    case "bigbet355.com":
      return "BIGBET";
    case "baste247.com":
      return "BASTE 24/7";
    case "bob365bet.com":
      return "bob365";
    case "euro365.live":
    case "euro365ex.co":
      return "EURO365";
    case "better365.live":
      return "BETTER365";
    case "365eurobet.com":
      return "EUROB3T";
    case "tipwin356.com":
    case "localhost:8080":
      return "tip365";
    case "lek365.com":
      return "LEK365";
    case "porta365.com":
      return "PORTA365";
    case "blu90.com":
      return "BLU90";
    case "kosovabet365.net":
      return "KOSOVABET";
    case "maxbets365.net":
      return "MAXBETS";
    case "maxb3t.com":
      return "maxb3t";
    case "bileta365.com":
      return "BILETA365";
    case "gota365.com":
      return "inbet";
    case "albwin.co":
      return "ALBWIN";
    case "luckybet77777.com":
      return "77777";
    case "redvip247.co":
      return "redvip247";
    default:
      return `BET`;
  }
};

export const getPokerUrl = () => {
  if (
    location.host == "swissplay365.com" ||
    location.host == "romaplay365.com"
  ) {
    return "#/";
  }

  return "https://start.pokernex.net";
};
